<template>
  <nav>
    <a class="pa3 btn">
      <router-link to="/" active-class="active">
        <v-btn color="#6dbe45" class="btns" style="color: #ffffff">
          <v-icon style="color: #ffffff">keyboard_backspace</v-icon>Start Over
        </v-btn>
      </router-link>
    </a>
    <a class="pa3 btn">
      <router-link to="/purchase" active-class="active">
        <v-btn color="#6dbe45" class="btns" style="color: #ffffff">
          Continue shopping
        </v-btn>
      </router-link>
    </a>
  </nav>
</template>

<script>
export default {
  name: "CartHeader",
};
</script>

<style scoped>
.btns {  
  text-decoration: none;
  font-weight: 700;
  text-transform: unset !important;
  border-radius: 15px;
  box-shadow: 1px 1px 1px 1px #ffffff;
  margin: 10px;
}

a {
  text-decoration: none !important;
}
</style>
